import { render, staticRenderFns } from "./TsCommonTable.vue?vue&type=template&id=1c53943c&scoped=true&"
import script from "./TsCommonTable.vue?vue&type=script&lang=js&"
export * from "./TsCommonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53943c",
  null
  
)

export default component.exports